import { render, staticRenderFns } from "./step-two.vue?vue&type=template&id=2c84a8b9&scoped=true"
import script from "./step-two.vue?vue&type=script&setup=true&lang=ts"
export * from "./step-two.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./step-two.vue?vue&type=style&index=0&id=2c84a8b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c84a8b9",
  null
  
)

export default component.exports